import { render, staticRenderFns } from "./RedemptionSettings.vue?vue&type=template&id=721bfcd6"
import script from "./RedemptionSettings.vue?vue&type=script&lang=js"
export * from "./RedemptionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports